








import React from 'react'
import deluxeroom from "../images/deluxe_room berhampore.jpg";
import vilasini from "../images/vilasini.jpg";
import vilasiniroom from "../images/living_room.jpg";
import vilasiniroombath from "../images/bath_deluxe.jpg";
import vilasiniroombed from "../images/room_bed.jpg";


import vilasinibathroom from "../images/Vilasini_bathroom.jpg";


function Deluxevilasini() {
  return (
    <div>
        <div id="carouselExampleDark" className="carousel carousel-dark slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="2" aria-label="Slide 3"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="3" aria-label="Slide 4"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="4" aria-label="Slide 5"></button>
    <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="5" aria-label="Slide 6"></button>

  </div>
  <div className="carousel-inner">
    <div className="carousel-item active" data-bs-interval="10000">
    <img src={deluxeroom} className="d-block w-100" alt="deluxeroom"/>
      
    </div>
    <div className="carousel-item" data-bs-interval="2000">
    <img src={vilasini} className="d-block w-100" alt="vilasiniroom"/>
      
    </div>
    <div className="carousel-item">
    <img src={vilasiniroom} className="d-block w-100" alt="vilasiniroom"/>
      
    </div>
    <div className="carousel-item">
    <img src={vilasiniroombed} className="d-block w-100" alt="vilasiniroom"/>
      
    </div>
    <div className="carousel-item">
    <img src={vilasinibathroom} className="d-block w-100" alt="vilasiniroom"/>
      
    </div>
    <div className="carousel-item">
    <img src={vilasiniroombath} className="d-block w-100" alt="vilasiniroom"/>
      
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleDark" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Deluxevilasini